import { NaverLogin, NaverMobileLogin } from '../../assets';
import LoginNaver from 'react-login-by-naver';
import SocialLoginBtn from './SocialLoginBtn';
import { SocialLoginPlatformEnum } from './type';

export default function NaverLoginBtn({ afterSocialLoginSuccess, dataSocial }) {
  const handleLogin = (naverUser) => {
    afterSocialLoginSuccess({
      type: SocialLoginPlatformEnum.NAVER,
      socialId: naverUser.id,
      email: naverUser.email,
    });
  };

  return (
    <div data-social={dataSocial}>
      <LoginNaver
        clientId={process.env.REACT_APP_NAVER_CLIENT_ID}
        callbackUrl={process.env.REACT_APP_CALLBACK_URL}
        render={(props) => (
          <>
            <SocialLoginBtn 
              onClick={props.onClick}
              backgroundColor='bg-[#03C75A]'
              fontColor='text-white'
              icon={
                <>
                  <NaverLogin className='hidden md:block' width={24}/>
                  <NaverMobileLogin className='md:hidden block' />
                </>
              }
              text="naver"
            />
          </>
        )}
        onSuccess={(result) => {
          handleLogin({ id: result.id, type: 'naver', email: result.email });
        }}
        onFailure={() => console.error('failed')}
      />
    </div>
  );
}
